import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import logoImage from '../images/logo500.png';
import ModalAlert from '../components/ModalAlert.jsx';
import LoggedHomePage from './LoggedHomePage.jsx';
import LoaderModal from '../components/LoaderModal';

const LoginHomePage = ({ onLogin }) => {

  useEffect(() => {
    setIsModalAlert(true);
    dataFetch();
  }, [])

  //----- CHIAMATE PER I DATI DI ROBA -----//

  const [isFetchPending, setIsFetchPending] = useState(false);
  const [robaInfo, setRobaInfo] = useState(null)

  const dataFetch = async () => {
    setIsFetchPending(true);
    try {
      const [res1, res2, res3] = await Promise.all([
        fetch(`${process.env.REACT_APP_SERVER_BASE_URL}/users/usersCount`), // Utenti
        fetch(`${process.env.REACT_APP_SERVER_BASE_URL}/roba/objectsCount`), // Oggetti
        fetch(`${process.env.REACT_APP_SERVER_BASE_URL}/exchanges/exchangesCount`), // Scambi
      ]);

      if(!res1.ok || !res2.ok || !res3.ok) {
        throw new Error('Errore nella richiesta');
      }

      const users = await res1.json();
      const objects = await res2.json();
      const exchanges = await res3.json();

      setRobaInfo([users.payload, objects.payload, exchanges.payload]);

    } catch (error) {
      console.log('Error Type: ', error)
    }
    setIsFetchPending(false);
  }

  //-----//

  // ----- GESTIONE MODALE ALERT ----- //

  const [isModalAlert, setIsModalAlert] = useState(true);
  const handleOnClose = () => {
    setIsModalAlert(false);
  }

  // ----- //

  // ----- GESTIONE INPUT UTENTE ----- //

  const initialUserInput = {
    email: '',
    password: ''
  }

  const [userInput, setUserInput] = useState(initialUserInput);

  const handleInputData = (event) => {
    const { id, value } = event.target;
    setUserInput(prevUserData => ({
      ...prevUserData,
      [id]: value
    }));
  }

  useEffect(() => {
    console.log(userInput);
  }, [userInput])

  // ----- //

  // ----- CHIAMATA POST PER IL LOGIN ----- //

  const [errorMessage, setErrorMessage] = useState('');

  const navigate = useNavigate();

  const userLogin = async () => {
    setIsFetchPending(true);

    try {
      const response = await fetch(`${process.env.REACT_APP_SERVER_BASE_URL}/users/login`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(userInput)
      })
      if(response.ok) {
        const userDataObject = await response.json();
        console.log("Response data: ", userDataObject);
        localStorage.setItem('loggedUser', userDataObject.token);
        onLogin();
        navigate('/homepage');
      } else {
        const errorData = await response.json();
        console.log("Errore: ", errorData.message);
        setErrorMessage(errorData.message);
      }
    } catch (error) {
      console.log('Error type: ', error)
    }

    setIsFetchPending(false);
  }

  // ----- //

  // ----- LINK A REGISTRAZIONE ----- //

  const registerLink = () => {
    navigate('/register');
  }

  // ----- //

  //----- GENERAZIONE TESTO Cos'è Roba -----//

  const [isWhat, setIsWhat] = useState(false);

  const whatLink = () => {
    if(!isWhat){
      setIsWhat(true);
    } else {
      setIsWhat(false);
    };
  }

  //-----//

  return (
    <div className="container">
      <h1>Regala gli oggetti che non usi, riduciamo insieme gli sprechi.</h1>

        <img src={logoImage} id="logo-image" alt="Roba logo"/>

        <div className="login-container">

          <div className="border-box">
            <label htmlFor="email">Email:</label>
            <input type="email" id="email" placeholder="Inserisci la tua email" onChange={handleInputData} className={errorMessage ? 'wrong-input' : ''}></input>
            <label htmlFor="password">Password:</label>
            <input type="password" id="password" placeholder="Inserisci la tua password" onChange={handleInputData} className={errorMessage ? 'wrong-input' : ''}></input>
            <button onClick={userLogin}>Accedi</button>
            <a onClick={registerLink}><h5>(Non sei ancora registrato? Fallo ora!)</h5></a>
          </div>

          <div className="login-roba-data">
            {
              robaInfo && 
              <div>
                <h2><span style={{ color: '#94A684', fontSize: '50pt'}}>{robaInfo[0]}</span> <i>utenti</i> condividono i loro oggetti su ROBA.</h2>
                <h2><span style={{ color: '#94A684', fontSize: '50pt'}}>{robaInfo[1]}</span> <i>oggetti</i> totali in offerta.</h2>
                <h2><span style={{ color: '#94A684', fontSize: '50pt'}}> {robaInfo[2]}</span> <i>scambi</i> effettuati finora.</h2>
              </div>
            }
          </div>

        </div>

      {isModalAlert && <ModalAlert message="Benvenuto! Esegui il login per accedere alla piattaforma." expTime={6000} onClose={handleOnClose} />}
      {errorMessage && <ModalAlert message={errorMessage} expTime={3000} onClose={handleOnClose} />}
      {isFetchPending && <LoaderModal isFetchPending={isFetchPending} />}

      <button onClick={whatLink}>Cos'è <b>ROBA?</b></button>
      { isWhat &&
        <div className="border-box">
          <h3>Regala gli oggetti che non usi, riduciamo insieme gli sprechi.</h3>
  
          <p>ROBA è un marketplace geolocalizzato. Gli utenti hanno la possibilità di registrarsi e mettere in offerta i propri oggetti inutilizzati di cui desiderano liberarsi, regalandoli a qualcuno piuttosto che buttarli nella spazzatura o portarli in discarica.</p>

          <p><b>"INCENTIVARE E FAVORIRE IL RICICLO E CONTRIBUIRE A CONTENERE LA PRODUZIONE DI RIFIUTI E' L'OBIETTIVO PRINCIPALE DI ROBA"</b></p>

          <p>Partecipando al progetto ROBA come utente, hai la possibilità di liberarti di oggetti divenuti inutili per te, e magari ingombranti, grazie agli altri utenti che, richiedendo un tuo oggetto di cui potrebbero aver bisogno, offrono la loro disponibilità a venire a prenderlo direttamente a casa tua, evitandoti ogni scocciatura relativa ad un'eventuale spedizione o trasporto in discarica.</p>

          <p>Allo stesso modo, tu stess* hai la possibilità di richiedere e così avere un oggetto che qualcun altr* ha deciso di regalare. ROBA, dopo il login, mostra in home page gli oggetti offerti dagli altri utenti più vicini a casa tua.</p>

          <h4>Gli scambi sono equi e in essi nessuno dei due utenti coinvolti guadagna di più dell'altro, nessun utente si iscrive a fini di lucro o speculativi.</h4>

          <p>I prorietari degli oggetti possono, dopo una richiesta per un determinato oggetto, cambiare idea e scegliere di non cederlo. Nulla dev'essere forzato.</p>
          
          <h4>ROBA è creata per aiutarsi e contribuire insieme a ridurre gli sprechi e a rendere, nel nostro piccolo, questo mondo un posto migliore.</h4>

        </div>
      }

    </div>
  )
}

export default LoginHomePage;
